/**
 * Slice-5 run-config knob (PRD #803 / #821): which delivered-but-unbilled
 * units the practice-wide invoice run sweeps.
 *
 * - `ALL_DELIVERED` (default) — every eligible delivered unit, partial plans
 *   included. Matches slices 1-4 behaviour and serves as the monthly-sweep
 *   default.
 * - `COMPLETED_ONLY` — only units that belong to a treatment plan with
 *   `status == COMPLETED`. Used to bill plans whose completion nudge (#0) was
 *   missed without generating interim invoices for ongoing treatments.
 *
 * **Release coupling**: `COMPLETED_ONLY` is meaningful only once TM-9102
 * (auto-completion + one-time backfill) has populated `COMPLETED`. #3 and
 * TM-9102 ship to prod together; the temporary inconsistency before both
 * land is accepted (see PRD #803 Further Notes).
 */
export var InvoiceRunScopeMode;
(function (InvoiceRunScopeMode) {
    InvoiceRunScopeMode["ALL_DELIVERED"] = "all_delivered";
    InvoiceRunScopeMode["COMPLETED_ONLY"] = "completed_only";
})(InvoiceRunScopeMode || (InvoiceRunScopeMode = {}));
//# sourceMappingURL=invoice-run-scope-mode.enum.js.map